import { z } from 'zod';
import { applicationDateOrder, idArray, paymentReportsFilterSchema, transactionDateOrder } from './shared.schema';

export const rateTypeSchema = z.enum([
	'Monthly',
	'Validation',
	'Hotel Storage',
	'Office/Retail Rent',
	'Miscellaneous',
	'Applied Credit',
	'Carryover',
]);

export const paymentSummaryRateTypes = rateTypeSchema.options;

const dateOrderSchema = z.discriminatedUnion('dateOrder', [transactionDateOrder, applicationDateOrder]);

const commonFields = z.object({
	accountFilter: paymentReportsFilterSchema.optional(),
	rateTypes: z.array(rateTypeSchema).min(1),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
});

export const paymentSummaryParametersSchema = z
	.intersection(commonFields, dateOrderSchema)
	.superRefine((value, ctx) => {
		if (value.dateOrder === 'transactionDate' && value.applicationEndDate && !value.applicationStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['applicationEndDate'],
				message: 'Cannot specify an Application End Date without an Application Start Date',
			});
		}

		if (value.dateOrder === 'applicationDate' && value.transactionEndDate && !value.transactionStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['transactionEndDate'],
				message: 'Cannot specify a Transaction End Date without a Transaction Start Date',
			});
		}
	});

export type PaymentSummaryRateType = z.infer<typeof rateTypeSchema>;
export type PaymentSummaryParameters = z.infer<typeof paymentSummaryParametersSchema>;
